module.exports = "<p>\r\n  footer-two works!\r\n</p>\r\n"